import Query from "./query";

class GetTimeDuration extends Query {
    constructor() {
        super("getTimeDuration");
    }

    async execute(params) {
        return (params[0].getTime() - params[1].getTime()) / 1000;
    }
}

export default GetTimeDuration;